"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usersReadConfig = void 0;
exports.usersReadConfig = {
    canReadUsers: true,
};
